<template>
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
        <path fill="currentColor" d="M13.1918 2.80823H14.9224V4.53884H13.1918V2.80823ZM11.4612 6.26945V4.53884H13.1918V6.26945H11.4612ZM9.7306 8.00006V6.26945H11.4612V8.00006H9.7306ZM7.99999 9.73067H9.7306V8.00006H7.99999V9.73067ZM6.26938 11.4613H7.99999V9.73067H6.26938V11.4613ZM4.53877 11.4613V13.1919H6.26938V11.4613H4.53877ZM2.80816 9.73067H4.53877V11.4613H2.80816V9.73067ZM2.80816 9.73067H1.07755V8.00006H2.80816V9.73067Z"/>
    </svg>
</template>
